import { useTranslations } from 'next-intl'

import { EyeOpenIcon } from '@radix-ui/react-icons'
import { IconButton, Popover, Flex, CheckboxGroup, Text } from '@radix-ui/themes'

import { useTableContext, useTableStore } from '../context/table-context'

const TableToggleablePopover = <T,>() => {
    const t = useTranslations('table')

    const { toggleableColumns, store, columns } = useTableContext<T>()
    const hiddenColumns = useTableStore('hiddenColumns')

    if (toggleableColumns.size == 0)
        return null

    return (
        <Popover.Root>
            <Popover.Trigger>
                <IconButton variant="soft">
                    <EyeOpenIcon />
                </IconButton>
            </Popover.Trigger>
            <Popover.Content>
                <Flex direction="column" gap="2">
                    <Text weight="bold">{t('column-visibility-title')}</Text>
                    <CheckboxGroup.Root
                        value={[...toggleableColumns].filter(x => !hiddenColumns.includes(x))}
                        onValueChange={values =>
                            store.update({
                                hiddenColumns: [...toggleableColumns].filter(x => !values.includes(x)),
                            })
                        }
                    >
                        {columns.map((column, index) =>
                            column.toggleable && (
                                <CheckboxGroup.Item value={index.toString()} key={index}>
                                    {column.label}
                                </CheckboxGroup.Item>
                            )
                        )}
                    </CheckboxGroup.Root>
                </Flex>
            </Popover.Content>
        </Popover.Root>
    )
}

export default TableToggleablePopover
